"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = require("./styled");
var END_POINT = "https://github.com/PPO-F-MAN/react-season-component/blob/develop/public/asset/weather/cloudy";
var sun = END_POINT + "/sun.png?raw=true";
var cloud = END_POINT + "/cloud.png?raw=true";
var Cloudy = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styled_1.Sun, { imgSrc: sun }),
        react_1.default.createElement(styled_1.Infinity, null,
            react_1.default.createElement(styled_1.Cloud, { imgSrc: cloud }),
            react_1.default.createElement(styled_1.Cloud, { imgSrc: cloud })),
        children));
};
exports.default = Cloudy;
